<template>
  <div class="main" v-on:resize="handleResize()">
    <div class="projects__grid" v-if="windowWidth >= 780" :key="0">
      <img class="hello" src="../assets/hello.svg" v-parallax="0.1" alt="">
      <div class="projects-grid__tile-row about" v-parallax="0.1">
        <h2>{{ information[0].description.title }}</h2>
        <p>{{ information[0].description.paragraph1 }}</p>
        <p>{{ information[0].description.paragraph2 }}</p>
        <p>{{ information[0].description.paragraph3 }}</p>
      </div>
        <transition name="fade-in" appear>
            <div class="tile image_1">
                <img class="tile image_1" :src="this.information[0].images[0].title" alt="" v-parallax="0.2">
            </div>
        </transition>
      <img class="tile image_2" :src="this.information[0].images[1].title" alt="">
      <div class="projects-grid__tile-row services" v-parallax="0.3">
        <h2>{{ information[0].services.title }}</h2>
        <p>{{ information[0].services.service1 }}</p>
        <p>{{ information[0].services.service2 }}</p>
        <p>{{ information[0].services.service3 }}</p>
        <p>{{ information[0].services.service4 }}</p>
      </div>
      <div class="projects-grid__tile-row contact">
        <h2>Contact</h2>
        <p>{{general[0].contact.phone}}</p>
        <a :href="'mailto:' + general[0].contact.email"><p>{{ general[0].contact.email }}</p></a>
      </div>
      <div class="projects-grid__tile-row social">
        <a :href="general[0].social.instagram" target="_blank"><h2>Instagram</h2></a>
        <a :href="general[0].social.ello" target="_blank"><h2>Behance</h2></a>
        <a :href="general[0].social.behance" target="_blank"><h2>Ello</h2></a>
      </div>
    </div>
    <div class="projects__grid" v-if="windowWidth < 780" :key="1">
      <img class="hello" src="../assets/hello.svg" alt="">
      <div class="projects-grid__tile-row about">
        <h2>{{ information[0].description.title }}</h2>
        <p>{{ information[0].description.paragraph1 }}</p>
        <p>{{ information[0].description.paragraph2 }}</p>
        <p>{{ information[0].description.paragraph3 }}</p>
      </div>
      <img class="tile image_1" :src="this.information[0].images[0].title" alt="">
      <img class="tile image_2" :src="this.information[0].images[1].title" alt="">
      <div class="projects-grid__tile-row services">
        <h2>{{ information[0].services.title }}</h2>
        <p>{{ information[0].services.service1 }}</p>
        <p>{{ information[0].services.service2 }}</p>
        <p>{{ information[0].services.service3 }}</p>
        <p>{{ information[0].services.service4 }}</p>
      </div>
      <div class="projects-grid__tile-row contact">
        <h2>Contact</h2>
        <p>{{general[0].contact.phone}}</p>
        <a :href="'mailto:' + general[0].contact.email"><p>{{ general[0].contact.email }}</p></a>
      </div>
      <div class="projects-grid__tile-row social">
        <a :href="general[0].social.instagram" target="_blank"><h2>Instagram</h2></a>
        <a :href="general[0].social.ello" target="_blank"><h2>Behance</h2></a>
        <a :href="general[0].social.behance" target="_blank"><h2>Ello</h2></a>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'about',
  data: function () {
    return {
      parallax: [0.1, 0.0, 0.0, 0.1, 0.0, 0.2, 0.0, 0.0, 0.0],
      windowWidth: window.innerWidth
    }
  },
  computed: {
    ...mapGetters([
      'general',
      'information'
    ])
  },
  methods: {
    handleResize () {
      this.windowWidth = window.innerWidth
    }
  },
  mounted: function () {
    window.addEventListener('resize', this.handleResize)
  },
  beforeDestroy: function () {
    window.removeEventListener('resize', this.handleResize)
  }
}
</script>
<style scoped lang="scss">
@import "../scss/vars";

@media screen and (min-width: $break-small) {
  .about {
    grid-column: 1;
    grid-row: 1 / span 2;
    z-index: 5;
  }
  .image_1 {
    grid-column: 2;
    grid-row: 2 / span 2;
    transition: all 0s;
  }
  .services {
    grid-column: 2;
    grid-row: 5 / span 1;
  }
  .image_2 {
    grid-column: 1;
    grid-row: 3 / span 2;
  }
  .social {
    grid-column: 1;
    grid-row: 5 / span 1;
    z-index: 5;
  }
  .contact {
    grid-column: 1;
    grid-row: 4 / span 1;
    z-index: 5;
  }
  .hello {
    grid-column: 2 / span 1;
    grid-row: 1;
    z-index: 5;
    width: 70%;
  }
  .tile-container {
    grid-row: span 2;
  }
}

@media screen and (min-width: $break-small) and (max-width: $break-large) {
  .projects__grid {
      grid-template-rows: repeat(12, 5em);
  }
  .about {
    grid-column: 2 / span 7;
    grid-row: 3;
    z-index: 5;
  }
  .image_1 {
    grid-column: 2 / span 5;
    grid-row: 8;
    z-index: 5;
    transition: all 0s;
  }
  .image_2 {
    grid-column: 2 / span 5;
    grid-row: 4;
  }
  .services {
    grid-column: 8 / span 4;
    grid-row: 8;
    z-index: 5;
  }
  .social {
    grid-column: 8 / span 4;
    grid-row: 16;
    z-index: 5;
  }
  .contact {
    grid-column: 8 / span 4;
    grid-row: 12;
    z-index: 5;
  }
  .hello {
    grid-column: 8 / span 3;
    grid-row: 1;
    z-index: 5;
    width: 100%;
  }
}

@media screen and (min-width: $break-large) {
  .projects__grid {
      grid-template-rows: repeat(12, 5em);
  }
  .about {
    grid-column: 7 / span 4;
    grid-row: 3;
    z-index: 5;
  }
  .image_1 {
    grid-column: 2 / span 4;
    grid-row: 1;
    z-index: 5;
    transition: all 0s;
  }
  .image_2 {
    grid-column: 2 / span 5;
    grid-row: 4;
  }
  .services {
    grid-column: 7 / span 2;
    grid-row: 9;
    z-index: 5;
  }
  .social {
    grid-column: 3 / span 3;
    grid-row: 10;
    z-index: 5;
  }
  .contact {
    grid-column: 9 / span 2;
    grid-row: 11;
    z-index: 5;
  }
  .hello {
    grid-column: 10 / span 2;
    grid-row: 1;
    z-index: 5;
    width: 100%;
  }
}

@media screen and (min-width: 1700px) {
  .social {
    grid-column: 3 / span 3;
    grid-row: 11;
    z-index: 5;
  }
}

</style>
